export const categories = [
  {
    slug: 'shooting-tips',
    name: '拍摄技巧',
    icon: 'ri-camera-lens-line',
    description: '从基础构图到高级拍摄手法，掌握亚洲自拍的专业技巧',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20taking%20selfie%20with%20professional%20camera%20in%20natural%20sunlight%2C%20soft%20warm%20tones%2C%20minimal%20composition%2C%20clean%20background%2C%20editorial%20photography%20with%20gentle%20lighting%2C%20aesthetic%20lifestyle%20portrait%2C%20cream%20and%20beige%20color%20palette&width=800&height=500&seq=cat-shooting-tips&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'filter-styles',
    name: '滤镜与风格',
    icon: 'ri-palette-line',
    description: '最热门的亚洲滤镜推荐与调色技巧，打造独特个人风格',
    image: 'https://readdy.ai/api/search-image?query=Soft%20pastel%20mobile%20screen%20displaying%20photo%20editing%20app%20with%20various%20Korean%20style%20filters%2C%20warm%20pink%20and%20cream%20aesthetic%2C%20minimal%20flat%20lay%20with%20dried%20flowers%2C%20cozy%20vibes%2C%20natural%20daylight%2C%20editorial%20product%20photography&width=800&height=500&seq=cat-filter-styles&orientation=landscape',
    articleCount: 6,
  },
  {
    slug: 'equipment-lighting',
    name: '设备与灯光',
    icon: 'ri-lightbulb-line',
    description: '最佳自拍设备推荐与专业打光方法，让每一张都光彩照人',
    image: 'https://readdy.ai/api/search-image?query=Beauty%20ring%20light%20and%20smartphone%20tripod%20setup%20on%20minimal%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20modern%20home%20studio%20setup%2C%20cream%20walls%2C%20clean%20aesthetic%2C%20professional%20content%20creator%20equipment%2C%20soft%20textures&width=800&height=500&seq=cat-equipment&orientation=landscape',
    articleCount: 5,
  },
  {
    slug: 'beauty-selfie',
    name: '美妆自拍',
    icon: 'ri-magic-line',
    description: '亚洲美妆自拍全攻略，妆容、角度与后期处理一网打尽',
    image: 'https://readdy.ai/api/search-image?query=Asian%20beauty%20makeup%20flat%20lay%20with%20cosmetics%20and%20mirror%2C%20natural%20daylight%2C%20soft%20pink%20and%20peach%20tones%2C%20elegant%20minimal%20composition%2C%20editorial%20beauty%20photography%2C%20warm%20neutral%20background%2C%20clean%20aesthetic&width=800&height=500&seq=cat-beauty&orientation=landscape',
    articleCount: 7,
  },
  {
    slug: 'influencer-style',
    name: '网红风格',
    icon: 'ri-star-line',
    description: '深度解析亚洲网红自拍风格，学习最流行的社交平台美学',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20influencer%20posing%20with%20smartphone%20in%20modern%20cafe%20interior%2C%20warm%20natural%20light%20through%20window%2C%20stylish%20casual%20outfit%2C%20minimal%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20cozy%20ambiance&width=800&height=500&seq=cat-influencer&orientation=landscape',
    articleCount: 6,
  },
];

export const allCategories = categories;